import type { EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { isAutomaticCheckOnboarding } from './onboarding-properties';

const getOnboardingByIdOrFallback = (onboardings: EntityOnboarding[], onboardingId: string | null) => {
  const onboardingById = onboardings.find(onboarding => onboarding.id === onboardingId);
  // A passed automatic check has nothing to review, but a failed one, like a new watchlist hit, does.
  const onboardingWorthOpening = onboardings.find(
    onboarding => !isAutomaticCheckOnboarding(onboarding) || onboarding.status !== 'pass',
  );
  const firstOnboarding = onboardings.at(0);
  return onboardingById ?? onboardingWorthOpening ?? firstOnboarding;
};

export default getOnboardingByIdOrFallback;
